import { Navigation } from "@src/components";
import { PageLayout } from "@src/components";
import { Spinner } from "@src/components/Spinner";

export const LoadingView = () => {
  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: "Loading",
              disabled: true,
            },
          ]}
        />
      }
    >
      <div className="flex justify-center items-center h-full bg-card_bg rounded-lg">
        <div className="flex justify-center items-center gap-2 ">
          <Spinner className="w-4 h-4 fill-text_primary" />
        </div>
      </div>
    </PageLayout>
  );
};
